// Lib
import React from 'react';
import { Button } from '@mui/material';

// Components
import Feather from '../../Feather';
import { useStyles } from './PlusButtonStyles';

const PlusButton = ({ onClick = () => {}, style, className }) => {
  const { classes, cx } = useStyles();

  return (
    <Button
      id="plus-button"
      // eslint-disable-next-line react/forbid-component-props -- styles prop is part of this component API
      style={style}
      onClick={onClick}
      className={cx(classes.button, className)}>
      <Feather type="plus" />
    </Button>
  );
};

export default PlusButton;
